import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, Factory, FileStack, Package, Receipt, Hourglass, ArrowRight } from "lucide-react";

function Stat({ label, value, icon: Icon, accent }) {
  return (
    <div className="p-6 border-r border-b border-border">
      <div className="flex items-center justify-between">
        <span className="label-tech text-muted-foreground">{label}</span>
        <Icon className={accent ? "h-4 w-4 text-brand" : "h-4 w-4 text-muted-foreground"} />
      </div>
      <div className="mt-3 font-heading text-3xl font-bold tracking-tight">{value}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-6 md:p-8 max-w-7xl">
      <div className="label-tech text-muted-foreground mb-1">Marketplace operations</div>
      <h1 className="text-3xl font-bold tracking-tight">Admin console</h1>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 border-t border-l border-border rounded-sm overflow-hidden bg-card">
        <Stat label="Buyers" value={stats?.buyers ?? "—"} icon={Users} />
        <Stat label="Suppliers" value={stats?.suppliers ?? "—"} icon={Factory} />
        <Stat label="Pending approvals" value={stats?.pending_suppliers ?? "—"} icon={Hourglass} accent />
        <Stat label="RFQs" value={stats?.rfqs ?? "—"} icon={FileStack} />
        <Stat label="Quotes" value={stats?.quotes ?? "—"} icon={Receipt} />
        <Stat label="Orders" value={stats?.orders ?? "—"} icon={Package} />
      </div>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <Link to="/admin/suppliers" data-testid="admin-goto-suppliers" className="group border border-border rounded-sm bg-card p-6 hover:border-brand transition-colors">
          <Factory className="h-6 w-6 text-brand" />
          <h3 className="mt-4 text-lg font-semibold">Supplier approvals</h3>
          <p className="mt-1 text-sm text-muted-foreground">Review, approve or reject supplier applications.</p>
          <span className="mt-3 inline-flex items-center gap-1 text-sm text-brand">Manage <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform" /></span>
        </Link>
        <Link to="/admin/rfqs" data-testid="admin-goto-rfqs" className="group border border-border rounded-sm bg-card p-6 hover:border-brand transition-colors">
          <Boxes className="h-6 w-6 text-brand" />
          <h3 className="mt-4 text-lg font-semibold">All RFQs</h3>
          <p className="mt-1 text-sm text-muted-foreground">Oversee marketplace demand and quote activity.</p>
          <span className="mt-3 inline-flex items-center gap-1 text-sm text-brand">View <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform" /></span>
        </Link>
      </div>
    </div>
  );
}

function Boxes(props) {
  return <Package {...props} />;
}
